import type bookingsOverviewAPIClient from '@/scopes/account/bookings-overview/infrastructure/bookingsOverviewApiClient'
import type { bookingsOverviewStore } from '@/scopes/account/bookings-overview/infrastructure/store'

export interface BookingsOverviewUseCases {
  apiClient: typeof bookingsOverviewAPIClient
  store: typeof bookingsOverviewStore
}

function bookingsOverviewUseCases({
  apiClient,
  store,
}: BookingsOverviewUseCases) {
  async function pageLoaded() {
    let data
    const state = store.getState()
    state.setIn('bookingOverviewPageLoadStatus', 'loading')
    try {
      data = await apiClient.getBookingsOverviewData()
      if (!data) {
        state.setIn('bookingOverviewPageLoadStatus', 'error')
        return
      }
    }
    catch {
      state.setIn('bookingOverviewPageLoadStatus', 'error')
      return
    }
    state.initialize({
      cancelledBookings: data.cancelledBookings ?? {},
      pastBookings: data.pastBookings ?? {},
    })
    state.setIn('bookingOverviewPageLoadStatus', 'success')
  }

  return {
    pageLoaded,
  }
}

export default bookingsOverviewUseCases
